<template>
    <span class="">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.2333 20.3L13.6333 14.7C13.1333 15.1 12.5583 15.4167 11.9083 15.65C11.2583 15.8833 10.5666 16 9.83325 16C8.01659 16 6.47925 15.371 5.22125 14.113C3.96259 12.8543 3.33325 11.3167 3.33325 9.5C3.33325 7.68333 3.96259 6.14567 5.22125 4.887C6.47925 3.629 8.01659 3 9.83325 3C11.6499 3 13.1876 3.629 14.4463 4.887C15.7043 6.14567 16.3333 7.68333 16.3333 9.5C16.3333 10.2333 16.2166 10.925 15.9833 11.575C15.7499 12.225 15.4333 12.8 15.0333 13.3L20.6583 18.925C20.8416 19.1083 20.9333 19.3333 20.9333 19.6C20.9333 19.8667 20.8333 20.1 20.6333 20.3C20.4499 20.4833 20.2166 20.575 19.9333 20.575C19.6499 20.575 19.4166 20.4833 19.2333 20.3ZM9.83325 14C11.0833 14 12.1459 13.5627 13.0213 12.688C13.8959 11.8127 14.3333 10.75 14.3333 9.5C14.3333 8.25 13.8959 7.18733 13.0213 6.312C12.1459 5.43733 11.0833 5 9.83325 5C8.58325 5 7.52059 5.43733 6.64525 6.312C5.77059 7.18733 5.33325 8.25 5.33325 9.5C5.33325 10.75 5.77059 11.8127 6.64525 12.688C7.52059 13.5627 8.58325 14 9.83325 14Z"
                fill="currentColor"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'MagnifyingGlassIcon',
    props: {},
    computed: {}
}
</script>
